import React from 'react'
import './ErrorBlock.css'

const ErrorBlock = ({title}) => {
  return (
    <span className='customErrorBlock'><span className='errorMsgIcon'>i</span>{title}</span>
  )
}

export default ErrorBlock
